module.exports = __webpack_public_path__ + "img/canbadge_rectangle_yoko_trimmark.674adc68.png";